export const isPresentedList = (list?: any[] | null): boolean =>
  list !== null && list !== undefined && list.length > 0;
